import axiosInstance, { apiRequest } from '../axiosInstance';
import { AI_USAGE_ENDPOINTS, buildQueryString } from '../endpoints';

const aiUsageLogService = {
  getLogs: async (params) => {
    return apiRequest(() =>
      axiosInstance.get(`${AI_USAGE_ENDPOINTS.LIST}${buildQueryString(params)}`)
    );
  },

  getSummary: async (params) => {
    return apiRequest(() =>
      axiosInstance.get(`${AI_USAGE_ENDPOINTS.SUMMARY}${buildQueryString(params)}`)
    );
  },
};

export default aiUsageLogService;
